import MovePrompt from './MovePrompt';
export default MovePrompt;
